import { useRef } from 'react'
import { Field } from 'formik'
import classnames from 'classnames/bind'
import * as styles from './index.module.css'
import { Spinner } from '~/components'

const cx = classnames.bind(styles)

export default function TwoOptionSwitch({ isChecked, option1, option2, icon1, icon2, showSpinner, name, field, form, onChange, onBlur, innerRef, ...props }) {
  const inputRef = useRef()

  const onKeyDown = e => {
    if (e.keyCode === 32) {
      e.preventDefault()
    }
  }

  const onKeyUp = e => {
    if (e.keyCode === 32) {
      e.preventDefault()
      inputRef?.current?.click()
      if (props.onClick) {
        props.onClick()
      }
    }
  }

  const handleChange = e => {
    onChange(e)
    form.setFieldTouched(name, true, false)
  }

  const option1ChekckedPrintout = <>{option1} <div className={cx(styles.checkbox, { isChecked:true })}></div></>
  const option1Printout = <>{option1} <div className={cx(styles.checkbox, { isChecked:false })}></div></>
  const option2ChekckedPrintout = <>{option2} <div className={cx(styles.checkbox, { isChecked:true })}></div></>
  const option2Printout = <>{option2} <div className={cx(styles.checkbox, { isChecked:false })}></div></>

  const iconSwitch = icon1 && icon2;

  return (
    <div className={cx(styles.wrapper, {isIcon:icon1 && icon2})}>
      { iconSwitch && 
        <label ref={innerRef} tabIndex={props?.disabled ? -1 : props?.tabIndex} className={cx(styles.label, { isChecked })} onKeyDown={onKeyDown} onKeyUp={onKeyUp}>
          <span className={styles.optionLabel}><img src={`/app/themes/taxi-stockholm/static/img/option-icons/${icon1}.png`} className={styles.icon} /></span>
          <span className={styles.optionLabel}><img src={`/app/themes/taxi-stockholm/static/img/option-icons/${icon2}.png`} className={styles.icon} /></span>
          <div className={cx(styles.toggle, {isIcon:true})}>{isChecked ? 
              (icon2 ? (<img src={`/app/themes/taxi-stockholm/static/img/option-icons/${icon2}Filled.png`} className={styles.icon} />) : '') :
              (icon1 ? (<img src={`/app/themes/taxi-stockholm/static/img/option-icons/${icon1}Filled.png`} className={styles.icon} />) : '')}
              {showSpinner && <div className={styles.spinner}><Spinner /></div>}
          </div>
          <Field 
            type="checkbox" 
            as="input"
            innerRef={inputRef}
            className={styles.field} 
            name={name}
            onChange={handleChange} 
            onBlur={onBlur} 
            {...props} 
            tabIndex="-1"
          />
        </label>
      }
      { !iconSwitch && 
        <label ref={innerRef} tabIndex={props?.disabled ? -1 : props?.tabIndex} className={cx(styles.label, { isChecked })} onKeyDown={onKeyDown} onKeyUp={onKeyUp}>
          <span className={cx(styles.optionLabel, { isDisabled : props?.disabled })}>{option1Printout}</span>
          <span className={cx(styles.optionLabel, { isDisabled : props?.disabled })}>{option2Printout}</span>
          <div className={styles.toggle}>{isChecked ? 
              (option2 ? option2ChekckedPrintout : icon2 ? (<img src={`/app/themes/taxi-stockholm/static/img/option-icons/${icon2}Filled.png`} className={styles.icon} />) : '') :
              (option1 ? option1ChekckedPrintout : icon1 ? (<img src={`/app/themes/taxi-stockholm/static/img/option-icons/${icon1}Filled.png`} className={styles.icon} />) : '')}
              {showSpinner && <div className={styles.spinner}><Spinner light/></div>}
          </div>
          <Field 
            type="checkbox" 
            as="input"
            innerRef={inputRef}
            className={styles.field} 
            name={name}
            onChange={handleChange} 
            onBlur={onBlur} 
            {...props} 
            tabIndex="-1"
          />
        </label>
      }
    </div>
  )
}
